/*
 * @Author: EdwardYoung
 * @Date: 2017-07-25 16:34:20
 * @Last Modified by: EdwardYoung
 * @Last Modified time: 2017-08-22 16:54:17
 */

import axios from 'api/axios.js'
import {createApiHeader} from './createApiHeader.js'

/**
 * @param {用户砍价id} id
 * @return {用户砍价信息}
 */

async function getFriendsActivityInfById (id) {
  return new Promise((resolve, reject) => {
    window.yhsd.ready(function (sdk) {
      sdk.account.current(function (User) {
        createApiHeader(axios, User.res.customer)
        _getFriendsActivityInfById(id).then((res) => {
          resolve(res.data.data)
        })
      })
    })
  })
}

/**
 * 根据活动id拉取活动信息
 */
function _getFriendsActivityInfById (id) {
  const activityInfUrl = `/v1/front/play_records/${id}`
  return axios({
    method: 'get',
    url: activityInfUrl
  })
}

export {getFriendsActivityInfById}



// WEBPACK FOOTER //
// ./src/api/getFriendsActivityInfById.js